<template>
    <div class="item">
        <div class="logo"><img src="../assets/logo.png" alt="logo"></div>
        <div class="button-home"><router-link to="/"><img src="../assets/buttons/button_home.svg" alt="button home"></router-link></div>
        <div class="button-map"><router-link to="/kaart"><img src="../assets/buttons/button_map.svg" alt="button map"></router-link></div>
        <div class="button-map-reunies"><router-link to="/reuniekaart"><img src="../assets/buttons/button_map_reunies.svg" alt="button map"></router-link></div>
        <div v-if="prevId !== -1" class="button-left"><img src="../assets/buttons/button_left.svg" alt="button left" @click="itemGo(prevId)"></div>
        <div v-if="nextId !== -1" class="button-right"><img src="../assets/buttons/button_right.svg" alt="button right" @click="itemGo(nextId)"></div>
        <div class="pin">{{ pin }}</div>
        <div class="title">{{ title }}</div>
        <div v-if="prent !== ''" class="prent"><img :src="prent"></div>
        <div v-if="prent !== ''" class="prent-titel">Detail muurschildering</div>
        <div class="image"><img :src="image"></div>
        <div class="story">{{ story }}</div>
    </div>
</template>

<script>
import config from '../config/app.json';
import axios from 'axios';
import router from '../router';
export default {
    name: 'Item',
    props: ["itemId"],
    methods: {
        itemGo: function(idIn) {
            router.replace('/item/'+idIn);
            location.reload();
        }
    },
    data() {
        return {
            title: '',
            story: '',
            story_html: '',
            pin: '',
            image: '',
            prent: '',
            nextId: -1,
            prevId: -1
        }
    },
    created() {
        axios.get(config.api + 'items/' + this.itemId +'?key=' + config.api_key)
            .then((res) => {
                const dataIn = res.data;
                dataIn.element_texts.forEach(text_element => {
                    if(text_element.element.name === 'Title') {
                        this.title = text_element.text;
                    }
                    if(text_element.element.name === 'Pin') {
                        this.pin = text_element.text;
                    }
                    if(text_element.element.name === 'Omschrijving') {
                        this.story = text_element.text;
                        this.story_html = text_element.html;
                    }
                });
                axios.get(config.api + 'files/?item=' + this.itemId +'&key=' + config.api_key)
                    .then((resFiles) => {
                        const fileData = resFiles.data;
                        fileData.forEach(fileFound => {
                            if(fileFound.file_urls.fullsize){
                                var fileOrgArray = fileFound.original_filename.split('/');
                                var fileOrgName = fileOrgArray[fileOrgArray.length - 1].split('.')[0];
                                // console.log('filename: '+fileOrgName);
                                if(fileOrgName.substring(fileOrgName.length -5) === 'prent'){
                                    this.prent=fileFound.file_urls.square_thumbnail;
                                } else {
                                    this.image = fileFound.file_urls.fullsize;
                                }
                            }
                        });
                        var opgeslagenPins = [];
                        if(localStorage.getItem('pinItems')) {
                            opgeslagenPins = JSON.parse(localStorage.getItem('pinItems'));
                            const currentIndex = opgeslagenPins.findIndex(x => x.pin === this.pin);
                            // console.log('uit geheugen, lengte pins: ' + opgeslagenPins.length);
                            // console.log('uit geheugen, current id: ' + opgeslagenPins[currentIndex].id);
                            // console.log('uit geheugen, current id +1: ' + opgeslagenPins[currentIndex+1].id);
                            if(currentIndex < opgeslagenPins.length - 1) {
                                this.nextId = opgeslagenPins[currentIndex + 1].id;
                            }
                            if(currentIndex > 0) {
                                this.prevId = opgeslagenPins[currentIndex - 1].id;
                            }
                            // console.log('uit geheugen, current id -1: ' + opgeslagenPins[currentIndex-1].id);
                            // console.log('uit geheugen, currentIndex: ' + currentIndex);
                        }
                    })
                    .catch()
            })
            .catch();
    }
}
</script>

<style scoped>

.item {
    background-color: #cccc99;
    width: 1920px;
    height: 1080px;
    overflow: hidden;
}

.story {
    position: absolute;
    top: 285px;
    left: 970px;
    width: 750px;
    height: 750px;
    overflow: hidden;
    color: #c1292f;
    font-weight: 700;
    font-size: 24px;
}
.title {
    position: absolute;
    top: 170px;
    left: 970px;
    width: 670px;
    height: 90px;
    color: #c1292f;
    font-weight: 900;
    font-size: 36px;
}
.pin {
    position: absolute;
    top: 95px;
    left: 970px;
    width: 100px;
    color: #c1292f;
    font-weight: 900;
    font-size: 48px;
}
.image {
    position: absolute;
    top: 285px;
    left: 430px;
    width: 520px;
    height: 750px;
    background-color: #00000011;
}
.image img {
    /* object-fit: contain; */
    object-position: 50% 0%;
    object-fit: scale-down;
    width: 100%;
    height: 100%;
}
.prent {
    position: absolute;
    top: 285px;
    left: 200px;
    width: 210px;
    height: 210px;
}
.prent img {
    object-fit: contain;
    /* object-position: 50% 0%; */
    /* object-fit: scale-down; */
    width: 100%;
    height: 100%;
}
.prent-titel {
    position: absolute;
    top: 500px;
    left: 200px;
    width: 210px;
    color: #c1292f;
    /* text-align: center; */
    font-weight: 700;
    font-size: 14px;
}
.button-home {
    position: absolute;
    top: 197px;
    left: 225px;
    width: 38px;
    height: auto;
}
.button-home img {
    width: 100%;
    height: auto;
}
.button-map {
    position: absolute;
    top: 194px;
    left: 288px;
    width: 50px;
    height: auto;
}
.button-map img {
    width: 100%;
    height: auto;
}
.button-map-reunies {
    position: absolute;
    top: 194px;
    left: 360px;
    width: 50px;
    height: auto;
}
.button-map-reunies img {
    width: 100%;
    height: auto;
}
.button-left {
    position: absolute;
    top: 200px;
    left: 433px;
    width: 40px;
    height: auto;
}
.button-left img {
    width: 100%;
    height: auto;
}
.button-right {
    position: absolute;
    top: 200px;
    left: 493px;
    width: 40px;
    height: auto;
}
.button-right img {
    width: 100%;
    height: auto;
}
.logo {
    position: absolute;
    top: 80px;
    left: 1645px;
    width: 120px;
    height: auto;
}
.logo img {
    width: 100%;
    height: auto;
}
</style>